export const fontWeights = {
    NORMAL: "normal",
    SEMI_BOLD: "600",
    BOLD: "bold",
};
